import CardButton from 'components/CardButton';
import DjangoMessages from 'components/DjangoMessages';
import NavigationTabs from 'components/Navigation/NavigationTabs';
import SectionHeader from 'components/SectionHeader';
import {FC} from 'react';
import {useBackend} from 'state/backend';
import {t} from 'ttag';
import {Backend} from 'types/api';

export type DocumentConversionSettingsBackend = Backend<{
    entries: Array<DocumentItem>;
}>;

type DocumentItem = {
    code: string;
    displayName: string;
};

const DocumentConversionSettingsRoot: FC = () => {
    const {data} = useBackend<DocumentConversionSettingsBackend>();

    return (
        <div>
            <DjangoMessages className="mb-2" />
            <NavigationTabs.DocumentSettings selection="conversionSettings" />
            <SectionHeader
                subtitle={t`Select the document type to convert to`}
                title={t`Conversion`}
            />
            <div className="mt-4 grid grid-cols-2 gap-4">
                {data.entries.map(({code, displayName}) => (
                    <CardButton
                        href={window.Urls.documentconversionsettings_by_type_react_view(
                            code,
                        )}
                        iconLeft="document"
                        iconRight="small_arrow_right"
                        key={displayName}
                    >
                        {displayName}
                    </CardButton>
                ))}
            </div>
        </div>
    );
};

export default DocumentConversionSettingsRoot;
